"use client";

export const TIMER_STORAGE_KEY = "puzzle-time";
export const setTimer = (state: TimeState) => {
  localStorage.setItem(TIMER_STORAGE_KEY, JSON.stringify(state));
};
export const clearTimer = () => {
  localStorage.removeItem(TIMER_STORAGE_KEY);
};
export const getTimer = () => {
  const timer = localStorage.getItem(TIMER_STORAGE_KEY);
  if (!timer) {
    return undefined;
  }
  return JSON.parse(timer) as TimeState;
};
export type TimeState = {
  date: string;
  seconds: number;
};
export const formatSeconds = (secondsNum: number) => {
  const minutes = Math.floor(secondsNum / 60);
  const seconds = secondsNum - minutes * 60;

  return `${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
};
